import { format } from 'date-fns'

import { IForm } from 'core-components/classes/models/IForm'

import { IColumnExtended } from '../../models/ITableExtendedProps'

import { loadTemplateData } from './loadTemplateData'

export const calcColumnRenderFunction = async (el: IColumnExtended) => {
  if (el.renderFunction) {
    const renderFunctionData = await loadTemplateData(el.renderFunction)
    if (renderFunctionData) {
      return renderFunctionData
    }
  }

  switch (el.renderType) {
    case 'booleanText':
      return (item: IForm, column: IColumnExtended) => `${Boolean(item[column.field])}`
    case 'booleanNumber':
      return (item: IForm, column: IColumnExtended) => `${Number(Boolean(item[column.field]))}`
    case 'dateText':
      return (item: IForm, column: IColumnExtended) =>
        formatDateTime(item[column.field], 'date', el.renderTypeDefaultValue)
    case 'dateTime':
      return (item: IForm, column: IColumnExtended) =>
        formatDateTime(item[column.field], 'time', el.renderTypeDefaultValue)
    case 'dateFull':
      return (item: IForm, column: IColumnExtended) =>
        formatDateTime(item[column.field], 'datetime', el.renderTypeDefaultValue)
    case 'number':
      return (item: IForm, column: IColumnExtended) =>
        getFormatNumber(item[column.field], '', el.renderTypeDefaultValue)
    case 'percentage':
      return (item: IForm, column: IColumnExtended) =>
        getFormatNumber(item[column.field], '%', el.renderTypeDefaultValue)
    case 'currencyUSD':
      return (item: IForm, column: IColumnExtended) =>
        getFormatNumber(item[column.field], '$', el.renderTypeDefaultValue)
    case 'currencyEuro':
      return (item: IForm, column: IColumnExtended) =>
        getFormatNumber(item[column.field], '€', el.renderTypeDefaultValue)
    default:
      return undefined
  }
}

function formatDateTime(
  dateRaw: unknown,
  type: 'date' | 'time' | 'datetime' = 'datetime',
  defaultValue: string = ''
): string {
  if (!dateRaw || typeof dateRaw !== 'string') {
    return defaultValue
  }

  const date = new Date(dateRaw)
  const isValid = date ? !isNaN(date.getTime()) : false
  if (!isValid) {
    return defaultValue
  }

  try {
    switch (type) {
      case 'date':
        return format(date, 'MMM do yyyy')
      case 'time':
        return format(date, 'HH:mm')
      case 'datetime':
      default:
        return `${format(date, 'MMM do yyyy')} | ${format(date, 'HH:mm')}`
    }
  } catch (err: unknown) {
    return ''
  }
}

const getFormatNumber = (value: unknown, postfix: string, defaultValue: string = '') => {
  if (value) {
    const numberValue = Number(value)
    if (!isNaN(numberValue)) {
      return `${numberValue.toLocaleString('ru')}${postfix}`
    }
  }
  return defaultValue
}
